import React from 'react';
import { CheckIcon, ClockIcon } from 'lucide-react';
import { BottomSheet } from './BottomSheet';
import { BeforeAfterSlider } from './BeforeAfterSlider';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
import type { Service } from '../types/business';
import { business } from '../data/business';
import { whatsappLink } from '../utils/whatsapp';
interface ServiceSheetProps {
  servico: Service | null;
  showPrecos: boolean;
  onClose: () => void;
}
export function ServiceSheet({
  servico,
  showPrecos,
  onClose
}: ServiceSheetProps) {
  return <BottomSheet open={Boolean(servico)} onClose={onClose} title={servico?.nome ?? ''} subtitle={servico?.resumo} data-id="element-113" data-mp="3k9gjnni275qw">
      {servico && <div className="pb-2" data-id="element-114" data-mp="3u4s1ieorkt2v">
          <div className="mt-2" data-id="element-115" data-mp="3u4ib4pzt4jwn">
            <BeforeAfterSlider antes={servico.imagemAntes} depois={servico.imagem} alt={servico.nome} data-id="element-116" data-mp="36fz2g9cui541" />
            <p className="mt-2 text-center text-[11.5px] text-muted" data-id="element-117" data-mp="31gvvgjdb1otf">
              Arraste com o dedo para comparar o antes e o depois
            </p>
          </div>

          <div className="mt-4 flex items-center gap-4 text-[13px] text-muted" data-id="element-118" data-mp="20ogdglmcilsn">
            <span className="flex items-center gap-1.5" data-id="element-119" data-mp="25fg6hfscgjpv">
              <ClockIcon className="h-4 w-4 text-mocha" strokeWidth={1.6} data-id="element-120" data-mp="25i2pcbkoqlne" />
              {servico.duracao}
            </span>
            {showPrecos && <span className="text-[15px] font-medium text-ink" data-id="element-121" data-mp="1cs2e7uzlccc3">
                {servico.preco}
                <span className="ml-1 text-[12px] font-normal text-muted" data-id="element-122" data-mp="1hplxj9b5bfaw">à vista</span>
              </span>}
          </div>

          <p className="mt-4 text-[14px] leading-relaxed text-muted" data-id="element-123" data-mp="1lqnwrq52brcv">{servico.descricao}</p>

          <ul className="mt-5 border-t border-shell pt-5 space-y-[6px]" data-id="element-124" data-mp="1qsd9da7xod32">
            {servico.destaques.map(item => <li key={item} className="flex items-start gap-2.5 text-[13.5px] text-ink" data-id="element-125" data-mp="2x6w4s739juvx">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-mocha" strokeWidth={1.8} data-id="element-126" data-mp="324nwazzzxezl" />
                {item}
              </li>)}
          </ul>

          <a href={whatsappLink(business.whatsapp, `Olá, ${business.profissional}! Quero agendar uma avaliação de "${servico.nome}". Quais horários você tem?`)} target="_blank" rel="noreferrer" className="mt-6 flex w-full items-center justify-center gap-2 rounded-2xl bg-ink px-5 py-4 text-[15px] font-medium text-cream transition-[background-color,transform] duration-150 ease-out hover:bg-[#3f352c] active:scale-[0.985] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mocha" data-id="element-127" data-mp="y2nt7202ak8y">
            <WhatsAppIcon className="h-[18px] w-[18px]" data-id="element-128" data-mp="obsxz84u8abd" />
            Agendar {servico.nome}
          </a>
          <p className="mt-3 text-center text-[11.5px] text-muted" data-id="element-129" data-mp="lp3prdjhmx1">
            Você será direcionado para uma conversa no WhatsApp
          </p>
        </div>}
    </BottomSheet>;
}